class ExternalDocument {

    constructor() {

        this._externalContentTemplate = null;       // Template principal
        this._externalContentListTemplate = null;   // Template desmontable con la lista de plataformas y el input
        this._externalContentDataTemplate = null;   // Template desmontable con los datos del iframe (Tarjeta)

        this._onSelectExternalContentCallback = null;
        this._onCancelExternalContentCallback = null;

        this._externalDocumentData = new ExternalDocumentData();

        this._loadTemplates();

    }

    _loadTemplates() {

        this._externalContentTemplate = Handlebars.compile($("#externalContentScreen").html());
        this._externalContentListTemplate = Handlebars.compile($("#externalContentList").html());
        this._externalContentDataTemplate = Handlebars.compile($("#externalContentData").html());

    }

    _enableScreenHandlers() {

        $("div.external-content.close-button").on("click.closeContentExternal", this._onClose.bind(this));
        $("div.external-content.confirm-button").on("click.confirmContentExternal", this._onConfirm.bind(this));

    }

    _enablePlatformsListScreenHandlers() {
        $("#iframe-searcher-form").on("submit.url", this._onSubmitUrl.bind(this));
        $("img.error-input-icon").on("click.clearSearch", this._onClearSearch.bind(this));
    }

    _enableDataScreenHandlers() {
        $(".card-wrapper > div.close-button").on("click.backToList", this._drawPlatformsList.bind(this));
    }

    _onSubmitUrl(event) {

        function _onGetContentSuccess(response) {

            if (api.checkisValidResult(response)) {

                that._externalDocumentData.setExternalContent(response.result);
                that._drawContentData();

            }

        }

        event.preventDefault();

        const $urlInput = $("input.iframe-searcher-input");
        const $iconInputError = $("img.error-input-icon");
        const $textInputError = $("p.error-input-text");
        const that = this;
        const searchTerm = $urlInput.val().trim();
        const validUrl = validateUrl(searchTerm);

        if (searchTerm.length > 0 && validUrl) {

            $textInputError.removeClass("visible");
            $iconInputError.hide();

            api.getExternalContent(searchTerm, _onGetContentSuccess);

        } else if (searchTerm.length > 0) {

            $textInputError.addClass("visible");
            $iconInputError.show();

        }

    }

    _onClearSearch(event) {

        const $this = $(event.currentTarget);
        const $searchInput = $("input.iframe-searcher-input");
        const $textInputError = $("p.error-input-text");

        $this.hide();
        $textInputError.removeClass("visible");
        $searchInput.val("");

    }

    _onConfirm(event) {

        const $this = $(event.currentTarget);
        const documentationNew = documentationScreenController.documentationNew;
        const documentationPublish = documentationScreenController.documentationPublish;
        const externalContentData = {
            title: this._externalDocumentData.getTitle(),
            description: this._externalDocumentData.getDescription(),
            card: this._externalDocumentData.getCard(),
            html: this._externalDocumentData.getHtml(),
            url: this._externalDocumentData.getUrl(),
            site: {
                logo: this._externalDocumentData.getLogo(),
                name: this._externalDocumentData.getSite()
            },
            duration: this._externalDocumentData.getDuration(),
            media: this._externalDocumentData.getMedia(),
            rel: this._externalDocumentData.getRel(),
            thumbnail: this._externalDocumentData.getThumbnail()
        }

        if ($this.hasClass("enabled")) {

            if (this._onSelectExternalContentCallback) {
                this._onSelectExternalContentCallback(externalContentData);
                this._onSelectExternalContentCallback = null;
            } else {
                documentationPublish.drawEnterTransitionScreen();
                documentationPublish.initialize(documentationNew.EXTERNAL, null, null, null, externalContentData);
            }

        }

    }

    _onClose(event) {

        const $publishSection = $("section.publish-section");
        const documentationNew = documentationScreenController.documentationNew;

        if ($publishSection.length > 0) {
            baseController.closeStack();
        } else {
            baseController.closeStack();
            window.scrollTo(0, documentationNew.lastYScrollPosition);
            documentationNew.onToggleNewButton();
        }

        if (this._onCancelExternalContentCallback) {
            this._onCancelExternalContentCallback();
            this._onCancelExternalContentCallback = null;
        }

        this._externalDocumentData.clearData();

    }

    _drawScreen() {

        const $body = $("body");
        const context = {};

        $body.removeClass("no-scroll");
        baseController.stackSimpleContent(this._externalContentTemplate, context, 'CONTENT');

        this._enableScreenHandlers();

    }

    _drawPlatformsList() {

        const $confirmButton = $("div.confirm-button");
        const $newDocumentContent = $(".new-document-section div.content");
        const context = {
            platforms: this._externalDocumentData.getPlatforms()
        };

        $confirmButton.removeClass("enabled");
        $newDocumentContent.html(this._externalContentListTemplate(context));

        this._enablePlatformsListScreenHandlers();

    }

    _drawContentData() {

        const $newDocumentContent = $(".new-document-section div.content");
        const $confirmButton = $("div.confirm-button");
        const context = {
            site: this._externalDocumentData.getSite(),
            logo: this._externalDocumentData.getLogo(),
            card: this._externalDocumentData.getCard(),
            url: this._externalDocumentData.getUrl(),
            title: this._externalDocumentData.getTitle(),
            thumbnail: this._externalDocumentData.getThumbnail()
        };

        $newDocumentContent.html(this._externalContentDataTemplate(context));
        $confirmButton.addClass("enabled");

        this._enableDataScreenHandlers();

    }

    initialize(fromEditor, onSelectExternalContentCallback, onCancelExternalContentCallback) {

        function _onGetPlatformsSuccess(response) {

            if (api.checkisValidResult(response)) {

                that._externalDocumentData.setPlatforms(response.result);
                that._onSelectExternalContentCallback = onSelectExternalContentCallback;
                that._onCancelExternalContentCallback = onCancelExternalContentCallback;

                that._drawScreen();
                that._drawPlatformsList();

                if (fromEditor) {

                    const $confirmButton = $("div.external-content.confirm-button");
                    $confirmButton.text(Translator.trans("TR_AÑADIR"));

                }

            }

        }

        const that = this;

        api.getExternalContentsProviders(_onGetPlatformsSuccess);

    }

    clearData() {
        this._externalDocumentData.clearData();
    }

}